import MyTable from "components/UIElements/MyTable";
import { useParams ,useLocation } from "react-router-dom";
import  EndPoints from 'shared/endPoints/EndPoints.json';



export default function Alarms() {
    const { id } = useParams();
    const endPoint = `${EndPoints.CONTRACT.GETCONTRACTΑLARMS}/?id=${id}`
    const location = useLocation();
    const exportFilename = `Anytime_BTM_Alarm_History_Contract_${location.state.policyNumber}`;


    const columns = [
        {
            title: 'Αριθμός Συμβολαίου',
            dataIndex: 'policyNumber',
            key: 'policyNumber',
        },
        {
            title: 'Αριθμός Πινακίδας',
            dataIndex: 'plateNumber',
            key: 'plateNumber',
        },
        {
            title: 'Ημερομηνία',
            dataIndex: 'dateCreated',
            key: 'dateCreated',
        },   
        {
            title: 'Τύπος',
            dataIndex: 'alarmType',
            key: 'alarmType',
        },

        {
            title: 'Περιγραφή',
            dataIndex: 'alarmDescription',
            key: 'alarmDescription',
        },
    ];

    return <MyTable columns={columns} endPoint={endPoint} exportFilename={exportFilename} ContractTab/>
}